import { SvgIcon, type SvgIconProps } from '@mui/material'

export const BaseIcon = ({ children, ...props }: SvgIconProps) => <SvgIcon {...props}>{children}</SvgIcon>

export type { SvgIconProps }
